import { Drawer, Form, Row, Tooltip } from 'antd'

import { Icon } from '@iconify/react/dist/iconify.js'
import FilterForm from './FilterForm'

const FilterDrawer = (props) => {
    const {
        stateTestCase,
        setStateTestCase = () => {},
        handleTestCaseList = () => {},
    } = props

    const isOpen = stateTestCase?.filterDrawer || false

    const handleClose = () => {
        const finalState = {
            ...stateTestCase,
            filterDrawer: false,
        }
        setStateTestCase(finalState)
    }

    const isEdit = stateTestCase?.action === 'edit'
    return (
        <Drawer
            placement="right"
            width={700}
            style={{
                height: '100vh',
                maxWidth: '700px',
            }}
            styles={{
                body: {
                    padding: '0px',
                    scrollbarColor: 'auto',
                    overflowX: 'hidden',
                    // height: '100vh',
                },
                wrapper: {
                    scrollbarColor: 'auto',
                },
                content: {
                    scrollbarColor: 'auto',
                },
            }}
            rootClassName="testReportDrawer"
            closeIcon={null}
            open={isOpen}
            title={
                <Row
                    justify="space-between"
                    style={{
                        columnGap: '15px',
                    }}
                    align="center"
                >
                    <span style={{ fontSize: '16px', fontWeight: '700' }}>
                        Filter
                    </span>
                    <Tooltip title="Close" placement="top">
                        <Icon
                            icon="ph:arrow-line-right"
                            onClick={() => {
                                handleClose()
                            }}
                            height={20}
                            width={20}
                            style={{
                                cursor: 'pointer',
                            }}
                        />
                    </Tooltip>
                </Row>
            }
        >
            <FilterForm
                stateTestCase={stateTestCase}
                setStateTestCase={setStateTestCase}
                handleClose={handleClose}
            />
            {/* <TestCaseForm
                stateTestCase={stateTestCase}
                setStateTestCase={setStateTestCase}
                handleTestCaseList={handleTestCaseList}
                handleClose={handleClose}
            /> */}
        </Drawer>
    )
}

export default FilterDrawer
